module.exports = __webpack_public_path__ + "img/2.4d383863.png";